import "bootstrap/dist/css/bootstrap.min.css";
import "../AppHeader.scss";

import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import Prompt from "../../../utils/Prompt";
import { t } from "../../../utils/ResourceUtils";
import GroupedNav from "./GroupedNav";
import RenderIcon from "./Icons/RenderIcon";

const init = {
  heading: t("cm.confirmation"),
  submitText: t("cm.proceed"),
  cancelText: t("cm.cancel"),
  contentText: t("cm.do_you_want_to_proceed"),
  onSubmit: "",
  onCancel: "",
  size: "md",
};

export const setActiveListItem = ({ e, item, redirectUrl, setActive, setShowConfirmDialog, history }) => {
  setActive(item);
  history.push({ pathname: redirectUrl });
  e.preventDefault();
  sessionStorage.removeItem("promptUser");
  sessionStorage.removeItem("promptMessage");
  setShowConfirmDialog(false);
};

const RheaSideNav = () => {
  const history = useHistory();
  const [groupedPermissions, setGroupedPermissions] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [isExpanded] = useState(false);
  const [isExpandedByNav, setIsExpdandedByNav] = useState(false);
  const [lockNav, setLockNav] = useState(false);
  const [active, setActive] = useState("");
  const permissionList = JSON?.parse(localStorage.getItem("permissions") || "[]");
  try {
    const jwtToken = JSON?.parse(localStorage?.getItem("loginResponse"))?.object?.jwt;
    if (!jwtToken) {
      localStorage.clear();
      sessionStorage.clear();
      history.push("/");
      window.location.reload();
    }
  } catch (error) {
    console.error("An error occurred:", error);
    // Handle the error gracefully, e.g., log out the user or display an error message
  }
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmDialogOptions, setConfirmDialogOptions] = useState(init);

  useEffect(() => {
    const items = permissionList?.filter((f) => f?.visible && f?.isModule);
    setGroupedPermissions(items);
  }, []);

  useEffect(() => {
    setLoaded(true);
  }, [groupedPermissions]);

  useEffect(() => {
    setLockNav(isExpanded);
  }, [isExpanded]);
  const hoverExpand = () => {
    !lockNav && setIsExpdandedByNav(true);
  };

  const hoverCollapse = () => {
    !lockNav && setIsExpdandedByNav(false);
  };

  const closePromptDialog = () => {
    setShowConfirmDialog(false);
  };

  const checkingDataToShowPrompt = (e, item, redirectUrl) => {
    if (sessionStorage.getItem("promptUser")) {
      setConfirmDialogOptions({
        ...init,
        contentText: sessionStorage.getItem("promptMessage") || init.contentText,
        onSubmit: () => setActiveListItem({ e, item, redirectUrl, setActive, setShowConfirmDialog, history }),
        onCancel: closePromptDialog,
      });
      setShowConfirmDialog(true);
    } else {
      setActiveListItem({ e, item, redirectUrl, setActive, setShowConfirmDialog, history });
    }
  };

  const groupedItems = _.groupBy(groupedPermissions, "groupName");

  const groupedItemsKey = () => {
    const ACI_KEY = t("cm.aci");
    const keys = [...Object.keys(groupedItems)];
    if (keys.includes(ACI_KEY)) {
      keys.splice(keys.indexOf(ACI_KEY), 1);
      keys.unshift(ACI_KEY);
    }
    return keys;
  };

  return (
    <>
      {loaded && (
        <nav
          id={`${isExpanded || isExpandedByNav ? "openNav" : "closeNav"}`}
          className={`${isExpanded || isExpandedByNav ? "nav" : "nav-closed"}`}
        >
          <aside className="" style={{ height: "60px", placeItems: "center", backgroundColor: "white" }}>
            <div>
              <img className="brand-logo" src={""} />
            </div>
          </aside>
          <div className="side-menu" style={{ overflowY: "auto", height: "95vh" }}>
            <div onMouseEnter={hoverExpand} onMouseLeave={hoverCollapse}>
              <ul className="nav-list">
                {groupedItemsKey()?.map((key) => {
                  const items = groupedItems[key];
                  return (
                    <GroupedNav
                      key={uuidv4()}
                      itemKey={key}
                      active={active}
                      RenderIcon={RenderIcon}
                      checkingDataToShowPrompt={checkingDataToShowPrompt}
                      items={items}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </nav>
      )}
      {showConfirmDialog && <Prompt options={confirmDialogOptions} open={showConfirmDialog} />}
    </>
  );
};

export default RheaSideNav;
